/**
 * Touch input state — written by ui/touch-ui.ts (virtual stick + buttons),
 * read by InputManager. On touch the game runs auto-aim + autofire
 * (docs/06): the player only steers and times dash/supershot.
 */
export class TouchState {
  moveX = 0;
  moveY = 0;
  superHeld = false;
  private dashQueued = false;
  private pauseQueued = false;
  lastActivity = 0;

  noteActivity(): void {
    this.lastActivity = performance.now();
  }

  queueDash(): void {
    this.dashQueued = true;
    this.noteActivity();
  }

  queuePause(): void {
    this.pauseQueued = true;
    this.noteActivity();
  }

  consumeDash(): boolean {
    const v = this.dashQueued;
    this.dashQueued = false;
    return v;
  }

  consumePause(): boolean {
    const v = this.pauseQueued;
    this.pauseQueued = false;
    return v;
  }
}
